import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Map } from 'immutable';

import { money } from 'src/utils/format';
import getErrorMessage, { mapErrors } from 'src/components/BetSlip/errors.jsx';

import Icon from 'src/components/Icon/Icon';
import symbols from 'src/config';
import { FreeBetSelector } from 'src/components/BetSlip/BonusEngineFreeBets/FreeBetSelector';

class Combination extends React.Component {
  static propTypes = {
    combination: ImmutablePropTypes.map,
    currency: ImmutablePropTypes.map,
    selectedSP: PropTypes.bool,
    isEmpty: PropTypes.bool,
    potentialReturns: PropTypes.number,
    allowRemoveLeg: PropTypes.bool,
    allowSaveLeg: PropTypes.bool,
    errors: PropTypes.oneOfType([
      ImmutablePropTypes.list,
      ImmutablePropTypes.map,
    ]),

    onMakeCombinationBet: PropTypes.func,
    onAddMultiple: PropTypes.func,
    onRemoveMultiple: PropTypes.func,
    bonusEngineFreeBets: PropTypes.array,
    selectedFreeBets: PropTypes.array,
    toggleFreeBet: PropTypes.func,
    clearFreeBetSelection: PropTypes.func,
    isBonusEngine: PropTypes.bool,
    userId: PropTypes.number,
  };

  static defaultProps = {
    combination: Map(),
    isEmpty: false,
    allowRemoveLeg: true,
    allowSaveLeg: true,
    onRemoveMultiple: () => {},
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      stakePerLine: 0,
      eachWay: false,
      potentialReturns: props.potentialReturns
        ? props.potentialReturns
        : props.combination.get('potentialReturns')
          ? 0
          : void 0,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (
      this.props.potentialReturns !== props.potentialReturns &&
      props.potentialReturns
    ) {
      this.setState({
        potentialReturns: props.potentialReturns,
      });
    }

    /*
        The stake needs to remain in the betslip stake box.

        if (this.state.stakePerLine > 0 && props.isEmpty) {
            this.clearMultiple();
        }*/
  }

  updateStake(stakePerLine) {
    this.setState({
      stakePerLine,
    });
  }

  clearMultiple() {
    const { combination, onRemoveMultiple } = this.props;

    this.setState({
      stakePerLine: 0,
      potentialReturns: 0,
    });
    onRemoveMultiple(combination);
  }

  change(data) {
    this.setState({
      eachWay: data.eachWay,
    });
    this.saveStake(data);
  }

  saveStake(data) {
    const { combination, onAddMultiple } = this.props;
    const { stakePerLine, eachWay } = this.state;
    let ew = data.hasOwnProperty('eachWay') ? data.eachWay : eachWay;

    let stake = parseFloat(stakePerLine);

    if (stake === 0 || isNaN(stake)) {
      this.clearMultiple();
    } else {
      onAddMultiple(combination.set('stakePerLine', stake).set('eachWay', ew));
    }
  }

  cleanStake() {
    const { stakePerLine } = this.state;
    this.setState({
      ...this.state,
      stakePerLine: stakePerLine ? stakePerLine : '',
    });
  }

  makeCombinationBet() {
    const { combination, onRemoveMultiple, onMakeCombinationBet } = this.props;
    const { stakePerLine, eachWay } = this.state;

    onMakeCombinationBet(
      combination.set('eachWay', eachWay),
      parseFloat(stakePerLine),
    );
    this.clearMultiple();
  }

  render() {
    const {
      combination,
      currency,
      selectedSP,
      errors,
      allowRemoveLeg,
      allowSaveLeg,
    } = this.props;
    const { potentialReturns, stakePerLine, eachWay } = this.state;
    let currencySymbol = symbols.symbols[currency.get('value')];

    let possibleReturns = selectedSP ? null : potentialReturns;

    const combinationLines = combination.get('numLines');

    let stakeLink = {
      value: stakePerLine,
      requestChange: this.updateStake.bind(this),
    };

    let errorsEl;
    if (errors && errors.size) {
      let mappedErrors = mapErrors(errors);

      errorsEl = mappedErrors
        .keySeq()
        .map((error) => {
          let details = mappedErrors.get(error);

          return <li key={error}>{getErrorMessage(details)}</li>;
        })
        .toArray()
        .map((error) =>
          error.constructor === String ? error : error.props.children,
        )
        .join('\n');
    }

    let returnsInfo, removeMultiple;
    if (stakePerLine > 0) {
      returnsInfo = (
        <div className="betslip-leg-returns">
          {possibleReturns ? (
            <div>
              Possible returns: {currencySymbol}
              {money(possibleReturns, currency)}
            </div>
          ) : (
            void 0
          )}
          {combination.get('maxStake') ? (
            <div>
              Cust. max bet: {currencySymbol}
              {money(combination.get('maxStake'), currency)}
            </div>
          ) : (
            void 0
          )}
        </div>
      );
      removeMultiple = allowRemoveLeg ? (
        <a
          href="#"
          className="betslip-leg-remove"
          onClick={this.clearMultiple.bind(this)}
        >
          &times;
        </a>
      ) : (
        void 0
      );
    }

    let ewCheckbox;
    if (
      (combination.get('ewOffered') || combination.get('eachWay')) &&
      combination.get('type') !== 'FC' &&
      combination.get('type') !== 'RFC' &&
      combination.get('type') !== 'CFC' &&
      combination.get('type') !== 'TC' &&
      combination.get('type') !== 'CTC'
    ) {
      ewCheckbox = (
        <div className="betslip-leg-options">
          <label className="checkbox betslip__each-way">
            <input
              type="checkbox"
              checked={!!eachWay}
              onChange={(e) => this.change({ eachWay: e.target.checked })}
            />{' '}
            EW
          </label>
        </div>
      );
    }

    return (
      <li className="betslip-leg--multiple betslip-leg--multiple-proposal">
        {removeMultiple}

        <div className="betslip-leg-amount combination">
          <div className="row" title={errorsEl}>
            <div className="col-6" style={errorsEl ? { color: 'red' } : void 0}>
              {selectedSP ? void 0 : combination.getIn(['price', 'f'])}
            </div>
            <div className="col-6">
              <div className="element">
                <span className="prefix">{currencySymbol}</span>
                <input
                  type="text"
                  value={stakeLink.value}
                  onChange={(e) => stakeLink.requestChange(e.target.value)}
                  onBlur={this.saveStake.bind(this)}
                  onClick={this.cleanStake.bind(this)}
                />
              </div>
            </div>
          </div>
          {this.props.bonusEngineFreeBets.some(
            (fb) => fb.freeBets.length > 0,
          ) &&
            this.props.isBonusEngine === true && (
              <FreeBetSelector
                betUid={this.props.combination.get('uid')}
                betType={this.props.combination.get('type')}
                userId={this.props.userId}
                bonusEngineFreeBets={this.props.bonusEngineFreeBets}
                currency={typeof currency === 'string' ? currency : ''}
                currencySymbol={currencySymbol}
                selectedFreeBets={this.props.selectedFreeBets}
                toggleFreeBet={this.props.toggleFreeBet}
                clearFreeBetSelection={this.props.clearFreeBetSelection}
              />
            )}
        </div>

        <span className="betslip-leg-name">
          {allowSaveLeg ? (
            <a
              href="#"
              className="betslip-leg-save"
              onClick={this.makeCombinationBet.bind(this)}
              data-test={`betslip-leg-save-${combination.get('name')}`}
            >
              <Icon name="save" />
            </a>
          ) : (
            void 0
          )}
          {combination.get('name')}{' '}
          {combinationLines ? combinationLines : void 0}
        </span>

        {returnsInfo}
        {ewCheckbox}
      </li>
    );
  }
}

export default Combination;
